import axios from "@/assets/axios_filter";
import SubFrame from "@/components/SubFrame";
import SwipeImage from "@/components/SwipeImage";
import TabFrame from "@/components/TabFrame";
import MintUI from "mint-ui";
import "mint-ui/lib/style.css";
import Vue from "vue";
import VuePhotoPreview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// Cookies.set("ASP.NET_SessionId", "alt5i5m1bqcclamp2y2zerpw");

Vue.component("tab-frame", TabFrame);
Vue.component("sub-frame", SubFrame);
Vue.component("swipe-image", SwipeImage);

Vue.use(MintUI);
Vue.use(VuePhotoPreview, { fullscreenEl: false });

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
